module.exports = __webpack_public_path__ + "static/media/window-frame.ccd43175.svg";